<template>
  <div class="gs-portal-section">
    <links-tab
      v-if="assetsTab === 'links' || assetsTab === 'recruitmentLinks'"
      :initial-group="assetsTab === 'recruitmentLinks' ? 'jv_broker_links' : 'aff_links'"
      @group-change="$emit('select', $event === 'jv_broker_links' ? 'recruitmentLinks' : 'links')"
      :funnel-resource="funnelResource"
      :direct-affiliate-links="directAffiliateLinks"
    />
    <stats-tab v-else-if="assetsTab === 'stats'" :funnel-resource="funnelResource" />
    <swipes-tab v-else-if="assetsTab === 'swipes'" :funnel-resource="funnelResource" />
    <blog-reviews-tab v-else-if="assetsTab === 'blogReviews'" :funnel-resource="funnelResource" />
    <all-articles-tab v-else-if="assetsTab === 'allArticles'" :funnel-resource="funnelResource" />
    <banners-tab v-else-if="assetsTab === 'banners'" :funnel-resource="funnelResource" />
    <thankyou-page-ads-tab v-else-if="assetsTab === 'thankyouPageAds'" :funnel-resource="funnelResource" />
    <logout-page-ads-tab v-else-if="assetsTab === 'logoutPageAds'" :funnel-resource="funnelResource" />
    <social-media-posts-tab v-else-if="assetsTab === 'socialMediaPosts'" :funnel-resource="funnelResource" />
    <video-reviews-tab v-else-if="assetsTab === 'videoReviews'" :funnel-resource="funnelResource" />
    <facebook-ads-tab v-else-if="assetsTab === 'facebookAds'" :funnel-resource="funnelResource" />
    <signatures-tab v-else-if="assetsTab === 'signatures'" :funnel-resource="funnelResource" />

    <!-- Every asset action confirms itself through `$gsToast`, which needs a
         provider mounted inside the widget; the hosted page has none of its
         own. The section area is the only place that raises kit toasts, so one
         provider here covers all twelve views. -->
    <gs-toast-provider />
  </div>
</template>

<script>
import LinksTab from './tabs/LinksTab.vue';
import SwipesTab from './tabs/SwipesTab.vue';
import BannersTab from './tabs/BannersTab.vue';
import ThankyouPageAdsTab from './tabs/ThankyouPageAdsTab.vue';
import SignaturesTab from './tabs/SignaturesTab.vue';
import SocialMediaPostsTab from './tabs/SocialMediaPostsTab.vue';
import BlogReviewsTab from './tabs/BlogReviewsTab.vue';
import VideoReviewsTab from './tabs/VideoReviewsTab.vue';
import FacebookAdsTab from './tabs/FacebookAdsTab.vue';
import LogoutPageAdsTab from './tabs/LogoutPageAdsTab.vue';
import AllArticlesTab from './tabs/AllArticlesTab.vue';
import StatsTab from './tabs/StatsTab.vue';
import '@/components/promotools/promo-sections.css';

export default {
  components: {
    LinksTab,
    SwipesTab,
    BannersTab,
    ThankyouPageAdsTab,
    SignaturesTab,
    SocialMediaPostsTab,
    BlogReviewsTab,
    VideoReviewsTab,
    FacebookAdsTab,
    LogoutPageAdsTab,
    AllArticlesTab,
    StatsTab,
  },
  props: {
    assetsTab: {
      required: true,
    },
    funnelResource: {
      required: true,
    },
    directAffiliateLinks: {
      required: true,
    },
  },
};
</script>

<style scoped>
.gs-portal-section {
  min-width: 0;
}
</style>
